export default __webpack_public_path__ + "media/zurb/img/icons/favicon/apple-touch-icon-144x144-762aa9f01d050be282e42e85cf098f38.png";